import { Box } from '@mui/material';

import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';

const ImageFormatSelection = () => {
  const { setExportSettings, exportSettings } = useExport();
  const onClick = (type: string) => {
    setExportSettings(prevState => {
      return { ...prevState, exportSubType: type };
    });
  };
  const buttons = [
    { label: 'PNG', type: 'image/png' },
    { label: 'PDF', type: 'application/pdf' },
    { label: 'JPEG', type: 'image/jpeg' },
    { label: 'SVG', type: 'image/svg+xml' }
  ];
  return (
    <Box
      sx={{
        maxHeight: 150,
        fontSize: 16,
        fontWeight: 600,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        flexWrap: 'wrap'
      }}
    >
      {buttons.map(({ label, type }) => (
        <Box
          key={label}
          sx={{ mt: 1 }}
        >
          <Box
            sx={{
              border: '1px solid',
              borderColor: exportSettings.exportSubType === type ? 'white' : 'transparent',
              backgroundColor: 'secondary.main',
              px: 1,
              py: 0.5
            }}
            onClick={() => {
              onClick(type);
            }}
          >
            {label}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ImageFormatSelection;
